export default {
  title: 'Optjen point og få belønninger',
  header: {
    pickup: 'Afhentning om 5 minutter',
  },
  recommendations: {
    title: 'Anbefalet',
  },
  discounts: {
    title: 'Rabatter',
    data: [
      {
        title: '+125 ekstrapoint',
        description: 'Bedøm os på Google',
      },
      {
        title: '+{{amount}} rabat',
        description: '+{{amount}} rabat, når du betaler med koden {{code}}',
      },
    ],
    button: {
      add: '+ Tilføj',
    },
  },
  rewards: {
    title: 'Belønninger og kuponer',
    balance: 'Saldo',
    points: 'Point',
  },
};
